import React, { ReactNode } from "react";

interface TooltipProps {
  tooltip: ReactNode | null;
}

const WithTooltip: React.FC<TooltipProps> = ({ tooltip, children }) => {
  return (
    <div className="inline-block">
      <span className="peer">{children}</span>
      {tooltip && (
        <div className="hidden peer-hover:block absolute z-10 bg-white shadow-md rounded-md p-4 text-gray-700 text-base text-left max-w-sm">
          {tooltip}
        </div>
      )}
    </div>
  );
};

export default WithTooltip;
